import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OneDialogModule, OneSnackBarModule } from '@one/angular-kit/modal';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { OneIconModule } from '@one/angular-kit/icon';
import { MatListModule } from '@angular/material/list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NotificationDocComponent } from './notification-doc.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OneFormFieldModule } from '@one/angular-kit/form';
import { OneTableModule } from '@one/angular-kit/data-table';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { OneEditableDropdownModule,OneSelectDropdownModule } from '@one/angular-kit/form';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FileUploadFeatureModule } from '../fileUpload/file-upload.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [NotificationDocComponent],
  exports: [NotificationDocComponent],
  imports: [CommonModule, OneDialogModule,MatSelectModule, FileUploadFeatureModule,OneEditableDropdownModule,OneSelectDropdownModule,MatPaginatorModule,OneSnackBarModule, MatIconModule, MatButtonModule, MatListModule, MatCardModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule, OneIconModule, FormsModule, ReactiveFormsModule, OneFormFieldModule, OneTableModule, MatTableModule, CdkTableModule, MatCheckboxModule, MatSortModule, MatSlideToggleModule]
})
export class NotificationDocModule {}
